"use strict";
/**
 * Response 400 - the server cannot or will not process the request due to something that is perceived
 * to be a client error (e.g., malformed request syntax, invalid request message framing,
 * or deceptive request routing).
*/
const badRequestError = class BadRequestError extends Error {
    /**
     * @param {string} message optional
     */
    constructor(message) {
        super(message);
        this.status = 400;
    }
    toString() {
        return this.message;
    }
};
module.exports = badRequestError;
//# sourceMappingURL=badRequestError.js.map